import axios from 'axios';

const url = new URL(process.env.REACT_APP_API_URL || '');
const base_url = `${url.origin}${url.pathname}`;
const api = axios.create({
  baseURL: base_url
});

export { api };
